// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ContractChangePaymentMethodController = function ($scope, $routeParams, $location, $http, Contract, ProductInfo, 
        PaymentMethod, ContractChangePaymentMethod, PaymentMethodNames, nationalIdValidatorService, gettextCatalog, gettext) {
    var productInfo = ProductInfo.get(function () {
        $scope.contract = Contract.get({ contractId: $routeParams.contractId }, function () {
            $scope.plan = productInfo.PlanById($scope.contract.PlanId);
            $scope.planGroup = productInfo.PlanGroupById($scope.plan.PlanGroupId);
        });
    });
    $scope.paymentData = {};
    $scope.paymentRunning = false;
    //refactor together with Create Contract Controller when implemented debit payments on Contract
    function loadConfiguredPaymentMethods(callback) {
        PaymentMethod.query({ contractCreation: true }, function (data) {
            var result = { paymentMethods: data, paymentMethodEnum: [] };

            for (var i = 0; i < data.length; i++) {
                var value = data[i];
                result.paymentMethodEnum.push(value.Role + ":" + value.Provider);
            }
            callback(result);
        });
    }

    loadConfiguredPaymentMethods(function (paymentMethods) {
        $scope.paymentMethods = paymentMethods.paymentMethods;
        $scope.paymentMethodEnum = paymentMethods.paymentMethodEnum;
    });

    $scope.paymentMethodNamesEN = PaymentMethodNames.get();

    $scope.modifyFieldView = function(fieldName, isValid) {
        let input = document.getElementById(fieldName);
        if (!input) {
            return;
        }
        
        if (isValid){
            input.classList.remove("ng-invalid");
            input.style.color = "black";
            input.title = fieldName;
            input.removeAttribute('data-toggle');
        }
        else {
            input.classList.add("ng-invalid");
            input.style.color = "#b94a48";
            input.title = gettextCatalog.getString(gettext('Please check your input'));
            input.setAttribute('data-toggle', 'tooltip');
        }
        
    }    
    
    $scope.changePaymentMethod = function () {
        if ($scope.paymentRunning)
            return;

        if ($scope.paymentData.nationalIdNumber && !validateNationalId()){
            alert(gettextCatalog.getString(gettext('National Number Id is invalid. Please check your input')));
            return;
        }
        
        if ($scope.isDirectDebit() && !$scope.isIBANValid($scope.paymentData.iban)){
            alert(gettextCatalog.getString(gettext('IBAN is invalid. Please check your input')));
            return;
        }

        $scope.paymentRunning = true;
        ContractChangePaymentMethod.save({ contractId: $routeParams.contractId }, { selectedPaymentMethod: $scope.paymentMethod, bearer: $scope.paymentData },
            function () {
                $location.path("/contracts/" + $routeParams.contractId);
            },
            function () {
                $scope.paymentRunning = false;
            }
        );
    };

    $scope.dataInvalid = function() {
        return $scope.isDebit() && (
            !$scope.paymentMethod || $scope.paymentRunning || !$scope.paymentData
            || $scope.paymentData && (!$scope.isIBANValid($scope.paymentData.iban) || !$scope.paymentData.holder))
            || !$scope.contract || !!$scope.contract.WrittenOff;
    };

    $scope.$watch('paymentData.nationalIdNumber', function () {
        var isValid = validateNationalId();
        $scope.modifyFieldView('nationalIdNumber', isValid);
    });
    
    function validateNationalId() {
        var countryCode = nationalIdValidatorService.getCountryCodeForPaymentMethod($scope.paymentMethod);
        return nationalIdValidatorService.isNationalIdValid(countryCode, $scope.paymentData.nationalIdNumber);
    }
    
    $scope.isNationalIdNumberVisible = function () {
        return $scope.paymentMethod === 'Autogiro:PayExInvoiceService';
    }
    
    $scope.isDebit = function() {
        return $scope.paymentMethod === 'Debit:Paymill' ||
            $scope.paymentMethod === 'Debit:PayOne' || 
            $scope.paymentMethod === 'Debit:FakeProvider' ||
            $scope.paymentMethod === 'Debit:Wirecard' || 
            $scope.paymentMethod === 'Debit:SepaXml' ||
            $scope.paymentMethod === 'Debit:GoCardless' ||
            $scope.paymentMethod === 'Debit:Mollie' ||
            $scope.paymentMethod === 'Debit:UnzerV2';
    }

    $scope.$watch('paymentData.iban', function () {
        if ($scope.paymentData.iban) {
            $scope.paymentData.iban = $scope.paymentData.iban.replace(/\s/g, '').slice(0, 34).toUpperCase();
            var isValid = $scope.isIBANValid($scope.paymentData.iban);
            $scope.modifyFieldView('iban',  isValid);
        }
    });

    $scope.isIBANValid = function(iban) {
        // IBAN validation is implemented in the iban.js
        return IBAN.isValid(iban);
    }
    
    $scope.isDirectDebit = function() {
        return $scope.paymentMethod.startsWith("Debit:");
    }
};
ContractChangePaymentMethodController.$inject = ['$scope', '$routeParams', '$location', '$http', 'Contract', 'ProductInfo', 
    'PaymentMethod', 'ContractChangePaymentMethod', 'PaymentMethodNames', 'nationalIdValidatorService', 'gettextCatalog', 'gettext'];
